cb.define([], function () {
  var RM_rm_shiftreceipt_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
	  var report_id = 0;
	  var report_name = '';
	
	  viewmodel.on('publish', function () {
		 
		var report_id = viewmodel.get('reportId').getValue();
		if(report_id > 0){
		  viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0201', carryData: { query: {key:'reportId',value:report_id}, title: viewmodel.get('reportName').getValue()}}});
		  return;
	    }
		
		 // debugger;
        var proxy = cb.rest.DynamicProxy.create({
          settle: { url: 'report/publish', method: 'POST' }
        });
		
		var groupSchemaId = cb.rest.AppContext.option.pointQueryScheme;
		//alert(groupSchemaId);
		
		var commonVOs = [];
		var warehouse_names = viewmodel.get('shiftWarehouse').getValue();
		if(warehouse_names.length <= 0){
			cb.utils.alert("请选择仓库！");
			return false;
		}
		var warehouses=[];
		for(var i=0;i<warehouse_names.length;i++){
			warehouses.push(warehouse_names[i]['warehouse_name']);
		}
		var commonVO = {"itemName":"warehouse_name","value1":warehouses};
		commonVOs.push(commonVO);
		
		var filterVO = {"commonVOs":commonVOs};
		
        var params = {
			billnum : "stock_stockanalysis",
			reportName:"交班单库存量_" + viewmodel.get('createTime').getValue(), 
			condition : filterVO

        };
		
		if(groupSchemaId > 0){
			params.groupSchemaId = groupSchemaId;
		}else{
			params.groupSchemaName = "交班库存";
		}
					//groupSchemaName: "交班库存"
		
		
        proxy.settle(params, function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
		  if (result != undefined) {
			  viewmodel.get('reportId').setValue(result.id);
			  viewmodel.get('reportName').setValue(result.name);
			  
			  viewmodel.communication({ type: 'menu', payload: {menuCode:'SJ0201', carryData: { query: {key:'reportId',value:result.id}, title: result.name}}});
		  }
		  
        });
      });

    },
 
  }
  try {
    module.exports = RM_rm_shiftreceipt_VM_Extend;
  } catch (error) {

  }
  return RM_rm_shiftreceipt_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_shiftreceipt_VM.Extend.js